

module.exports = el => {
    let chn = [...el.childNodes];
    if (!(chn.length > 0)) return null;
    const data = require('../data');
    chn = chn[0];
    chn.innerHTML = data.mobileWarningMessage;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/utils/DisplayMobileMessage.js